import React, { useState, useEffect } from 'react'
import '../../css/pavFiltros/filtros.css'
import { Form, Col, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../components/clickstreamAnalise/clickstreamColeta.js'
import {
  filtrosArrayBarra,
  revelarBarraFiltragem,
  recarregarBarraFiltragem,
  maximoTagsExibidas
} from '../../redux/actions'
import { setaDropdown } from '../../utils/alternanciaIcones'

function FiltroSistema(props) {
  const [id, setId] = useState('')
  const [nome, setNome] = useState('')
  const [descricao, setDescricao] = useState('')

  const despacho = useDispatch()
  let recarregarBarraFiltragemValor = useSelector(
    (state) => state.filtrosState.recarregarBarraFiltragem
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let arrayFiltrosSimcard = []

  function hendlerGetdadosFiltros() {
    if (!filtros.vazio) {
      //seta os valores dos inputs
      setNome(filtros.ds_pav_sistema)
      setId(filtros.cd_pav_sistema)
      setDescricao(filtros.ds_descricao)
    }
  }
  useEffect(() => {
    hendlerGetdadosFiltros()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleFuncaoEstadosRedux() {
    ColetaClickstream(1361) /*pavSistemaTabelaGridDropFiltrosFiltrar*/
    if (id !== '' && id)
      arrayFiltrosSimcard.push('Id: ' + id + '?cd_pav_sistema')
    if (nome !== '' && nome)
      arrayFiltrosSimcard.push('Nome: ' + nome + '?ds_pav_sistema')
    if (descricao !== '' && descricao)
      arrayFiltrosSimcard.push('Descrição: ' + descricao + '?ds_descricao')

    despacho(maximoTagsExibidas(props.setRevelarDropFiltros))
    despacho(filtrosArrayBarra(arrayFiltrosSimcard))
    despacho(revelarBarraFiltragem(true))
    despacho(recarregarBarraFiltragem(!recarregarBarraFiltragemValor))
  }

  useEffect(() => {
    //Check se todas as variaveis estao limpas
    function handlerCheckarTudoLimpo(verificador = []) {
      if (nome == '') verificador.push(1)
      if (descricao == '') verificador.push(1)
      if (id == '') verificador.push(1)
      //tamanho igual a quantidade de variaveis
      if (verificador.length === 3) return false
      else return true
    }

    async function handlerAtivarBotoes() {
      //se for alterado algo vai abilitar os botoes
      if (
        props.primeiraVez &&
        !props.foiLimpado &&
        (await handlerCheckarTudoLimpo())
      )
        props.setFoiSelecionado(true)
      else props.setFoiSelecionado(false)
    }

    //limpa os dados de todas as variaveis
    if (props.foiLimpado) {
      setDescricao('')
      setNome('')
      setId('')
      props.setFoiLimpado(false)
    }

    handlerAtivarBotoes()
    props.setPrimeiraVez(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nome, descricao, id, props.foiLimpado])

  function validarNumero(id, valor) {
    const filtro = /^[0-9]+$/
    if (valor === '' || filtro.test(valor)) {
      if (id === 'campo-texto-id-sistema') {
        setId(valor)
      }
    }
  }

  return (
    <Form
      ref={props.modal}
      onSubmit={props.enviarFiltros}
      className="drop-acoes-container"
    >
      <div className="campo-select-triangulo-menor-cor-2" />
      <div className="drop-acoes-corpo fundo-cor-7">
        <div className="drop-acoes-lista-menu">
          <div
            className="drop-filtros-menu"
            onClick={(e) => {
              props.dropFiltros(
                e,
                'filtro-id-sistema',
                'imagem-filtro-id-sistema'
              )
              ColetaClickstream(
                1358
              ) /*pavSistemaTabelaGridDropFiltrosIDdoSistema*/
            }}
          >
            <Form.Label className="drop-filtros-menu-label fonte-cor-1 label-filtros-seta">
              ID do sistema{' '}
            </Form.Label>
            <img
              id="imagem-filtro-id-sistema"
              className="drop-acoes-menu-icone-desativado nao-selecionavel"
              src={setaDropdown()}
            />
          </div>
          <div className="drop-filtros-divisora campo-select-divisor-cor-1" />
          <div
            id="filtro-id-sistema"
            className="drop-filtros-lista-submenu dropdown-desativado-filtros"
          >
            <Form.Control
              name="cd_pav_sistema"
              className="campo-texto-cor-3 campo-texto-filtro"
              type="text"
              maxLength="45"
              value={id}
              placeholder="ID do sistema"
              onChange={(e) =>
                validarNumero('campo-texto-id-sistema', e.target.value)
              }
            />
            <div className="drop-filtros-divisora campo-select-divisor-cor-1" />
          </div>

          <div
            className="drop-filtros-menu"
            onClick={(e) => {
              props.dropFiltros(e, 'filtro-sistema', 'imagem-filtro-sistema')
              ColetaClickstream(
                1359
              ) /*pavSistemaTabelaGridDropFiltrosNomeDoSistema*/
            }}
          >
            <Form.Label className="drop-filtros-menu-label fonte-cor-1 label-filtros-seta">
              Nome do sistema{' '}
            </Form.Label>
            <img
              id="imagem-filtro-sistema"
              className="drop-acoes-menu-icone-desativado nao-selecionavel"
              src={setaDropdown()}
            />
          </div>
          <div className="drop-filtros-divisora campo-select-divisor-cor-1" />
          <div
            id="filtro-sistema"
            className="drop-filtros-lista-submenu dropdown-desativado-filtros"
          >
            <Form.Control
              name="ds_pav_sistema"
              className="campo-texto-cor-3 campo-texto-filtro"
              type="text"
              maxLength="45"
              placeholder="Nome do sistema"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
            <div className="drop-filtros-divisora campo-select-divisor-cor-1" />
          </div>

          <div
            className="drop-filtros-menu"
            onClick={(e) => {
              props.dropFiltros(
                e,
                'filtro-descricao',
                'imagem-filtro-descricao'
              )
              ColetaClickstream(
                1360
              ) /*pavSistemaTabelaGridDropFiltrosDescricao*/
            }}
          >
            <Form.Label className="drop-filtros-menu-label fonte-cor-1 label-filtros-seta">
              Descrição{' '}
            </Form.Label>
            <img
              id="imagem-filtro-descricao"
              className="drop-acoes-menu-icone-desativado nao-selecionavel"
              src={setaDropdown()}
            />
          </div>
          <div
            id="filtro-descricao"
            className="drop-filtros-lista-submenu dropdown-desativado-filtros"
          >
            <div className="drop-filtros-divisora campo-select-divisor-cor-1" />
            <Form.Control
              name="ds_descricao"
              className="campo-texto-cor-3 campo-texto-filtro"
              type="text"
              maxLength="45"
              placeholder="Descrição do sistema"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
            />
          </div>
          <div className="drop-filtros-divisora-final campo-select-divisor-cor-1" />
          <div className="botao-central-filtros">
            <Form.Row>
              <Col>
                <Button
                  disabled={props.foiSelecionado ? false : true}
                  type="submit"
                  onClick={() => handleFuncaoEstadosRedux()}
                  className={
                    props.foiSelecionado
                      ? 'botao-aplicar-filtro-habilitado fonte-cor-4'
                      : 'botao-aplicar-filtro-disable'
                  }
                  variant="default"
                >
                  Filtrar
                </Button>
                <Button
                  disabled={props.foiSelecionado ? false : true}
                  type="button"
                  onClick={props.limparFiltros}
                  className={
                    props.foiSelecionado
                      ? 'botao-limpar-filtro-habilitado fonte-cor-2'
                      : 'botao-limpar-filtro-disable'
                  }
                  variant="default"
                >
                  Limpar
                </Button>
              </Col>
            </Form.Row>
          </div>
        </div>
      </div>
    </Form>
  )
}

export default FiltroSistema
